import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    timeWindows: translate({ id: 'orders.edit.field.timeWindows' }),
  }))

  return api
}
